import React from 'react';
import { ToastContainer } from 'react-toastify'; // Make sure to import the ToastContainer component

const CustomToastContainer = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      sm={{ background: "red" }}
    />
  );
};

export { CustomToastContainer };
